module.exports = __webpack_public_path__ + "c56daa9c0c1a7bbf2f9bcdcbafdd055f.png";